import router from '@/router';

const LOGIN_SUCCESS = async ({ commit }, authToken) => {
  commit('LOGIN_SUCCESS', authToken);
  router.push({ name: 'apps' });
};

const LOGIN_FAILURE = async ({ dispatch }, error) => {
  dispatch('ALERT_DISPLAY', error);
};

const LOGOUT = async ({ commit }) => {
  commit('LOGOUT');

  router.push({ name: 'login' });
};

export default {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
};
